import { useEffect, useState } from 'react';

const AUTO_SAVE_TIME = 700;

const useAutoSave = ({ delay = AUTO_SAVE_TIME, request, skip = false, hasChange = false, requestData, callback }) => {
  const [saveState, setSaveState] = useState('saved');

  useEffect(() => {
    if (saveState === 'saved' && hasChange && !skip) {
      setSaveState('waitingToSave');
    }
  }, [saveState, requestData, hasChange, skip]);

  const hasDataChanged = saveState === 'waitingToSave';
  useEffect(() => {
    if (hasDataChanged && !skip) {
      const timeout = setTimeout(() => {
        setSaveState('saving');
        request(requestData).then((data) => {
          setSaveState('saved');
          callback?.(data);
        });
      }, delay);

      if (!hasChange) {
        clearTimeout(timeout);
      }

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [delay, requestData, hasDataChanged, skip, hasChange, request, callback]);

  return saveState;
};

export default useAutoSave;
